<template>
  <div>
    <el-row>
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20">
        <div class="title">
          <h1>AShareChain - A-Share Industry Chain Knowledge Graph Visualization Project</h1>
        </div>
        <div class="picture">
          <img src="../assets/project6_3.png.webp" />
        </div>
        <div class="abstract">
          Industrial knowledge graphs are alive like plants: always growing and deeply interconnected.
          <br /><br />
          Inspired by this idea, Chain Branch A is a visualization project designed for quantitative investment research users.
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project6_1.png.webp" />
        </div>
      </el-col>
      <el-col :span="10">
        <div class="sub-title">Comprehensive Database</div>
        <div class="text">
          Complete upstream-downstream industry chain visualization with clear structural relationships and progressive expansion.
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="sub-title">Real-time Data Capture</div>
        <div class="text">
          Real-time visualization of constituent stock market value and price movement, helping users quickly identify market dynamics.
        </div>
      </el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project6_2.png.webp" />
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project6_4.png.webp" />
        </div>
      </el-col>
      <el-col :span="10">
        <div class="sub-title">Full Industry Coverage</div>
        <div class="text">
          All 31 Shenwan Level-1 industries are included (the authoritative classification released by Shenwan Hongyuan Research Institute). The platform reads industry-chain relationships in real time and supports step-by-step expansion from Level-1 to Level-3 upstream and downstream relations.
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="sub-title">Open A-share Industry Database</div>
        <div class="text">
          The platform integrates open-source A-share industry data, allowing intuitive exploration of relationships between constituent stocks and their main products.
        </div>
      </el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project6_5.png.webp" />
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project6_6.png.webp" />
        </div>
      </el-col>
      <el-col :span="10">
        <div class="sub-title">Graph Search and Theme Modes</div>
        <div class="text">
          The system supports full-graph search and node highlighting, with free switching between Photosynthesis Mode and Deep Sea Mode (light and dark themes).
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Project6",
};
</script>

<style scoped>
.picture img {
  width: 100%;
}
.sub-title {
  margin-bottom: 20px;
  font-size: 18px;
  color: #333;
  font-weight: 400;
}
.text {
  font-size: 15px;
  color: #333;
  font-weight: 100;
  text-align: justify;
  line-height: 1.9;
}
.abstract {
  margin-top: 40px;
  font-size: 15px;
  color: #333;
  font-weight: 100;
  text-align: justify;
  line-height: 1.9;
}
.grid-content {
  min-height: 36px;
}
.title {
  margin-top: 100px;
  text-align: center;
}
.title h1 {
  font-size: 30px;
  font-weight: 100;
  letter-spacing: 4px;
  color: #333333;
}
</style>